import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  Stack,
  Avatar,
} from "@mui/material";
import { Person, Assignment } from "@mui/icons-material";

interface PatientData {
  patientName: string;
  patientId: string;
  dateOfBirth: string;
  oldPlanName: string;
  newPlanName: string;
}

interface PatientPlanDetailsProps {
  patientData: PatientData;
}

const PatientPlanDetails: React.FC<PatientPlanDetailsProps> = ({
  patientData,
}) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  return (
    <Card variant="outlined" sx={{ mt: 2 }}>
      <CardContent>
        <Stack direction="row" spacing={4}>
          {/* Patient Details */}
          <Box sx={{ flex: 1 }}>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{ mb: 2 }}
            >
              <Person color="primary" />
              <Typography variant="subtitle1" fontWeight="medium">
                Patient Information
              </Typography>
            </Stack>

            <Stack spacing={1}>
              <Typography variant="body1" fontWeight="medium">
                {patientData.patientName}
              </Typography>
              <Typography variant="body2">
                Patient ID: {patientData.patientId}
              </Typography>
              <Typography variant="body2">
                Date of Birth: {formatDate(patientData.dateOfBirth)}
              </Typography>
            </Stack>
          </Box>

          {/* Plan Details */}
          <Box sx={{ flex: 1 }}>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{ mb: 2 }}
            >
              <Assignment color="secondary" />
              <Typography variant="subtitle1" fontWeight="medium">
                Plan Information
              </Typography>
            </Stack>

            <Stack spacing={2}>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Current Plan
                </Typography>
                <Chip
                  label={patientData.oldPlanName}
                  variant="outlined"
                  size="small"
                  color="default"
                />
              </Box>
            </Stack>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default PatientPlanDetails;
